import { useContext } from "react";
import { TeamScopeContext, type TeamScopeValue } from "./TeamScope";

export function useTeamScope(): TeamScopeValue {
  const value = useContext(TeamScopeContext);

  if (!value) {
    throw new Error("useTeamScope must be used inside a TeamScopeProvider.");
  }

  return value;
}
